import { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { CLOUDN_COLORS, COLORS } from "../../constants/colors";
import { PaginationProps } from "../../constants/types";

const PublicPaging = (props: PaginationProps) => {
  const [pages, setPages] = useState<JSX.Element[]>([]);
  const [index, setIndex] = useState(0);

  const getPagingIndex = useCallback(() => {
    return Math.ceil(props.dataLength / 30) - index;
  }, [index, props.dataLength]);

  //   useEffect(() => {
  //     setIndex(0);
  //   }, [props.options]);

  useEffect(() => {
    const temp = [];
    for (let i = 0; i < (getPagingIndex() > 10 ? 10 : getPagingIndex()); i++) {
      temp.push(
        <PageNumber
          className={props.page.state === i + index && "current"}
          key={i}
          onClick={() => {
            props.page.setState(i + index);
          }}
        >
          {i + 1 + index}
        </PageNumber>
      );
    }

    setPages(temp);
  }, [props.dataLength, props.page, index]);

  const onClickPrev = useCallback(() => {
    setIndex(index - 10);
  }, [index]);
  const onClickNext = useCallback(() => {
    setIndex(index + 10);
  }, [index]);
  return (
    <Container>
      <PageNumber
        onClick={index !== 0 ? onClickPrev : () => {}}
        className={`arrow ${index === 0 && "limit"}`}
      >
      </PageNumber>
      {pages}
      <PageNumber
        onClick={getPagingIndex() > 10 ? onClickNext : () => {}}
        className={`arrow ${getPagingIndex() < 10 && "limit"}`}
      >
      </PageNumber>
    </Container>
  );
};

export default PublicPaging;

const Container = styled.div`
  width: 100%;
  height: 5%;
  box-sizing: border-box;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  .current {
    background-color: ${CLOUDN_COLORS.skyBlue};
  }

  .arrow:hover {
    border: 0.18vw solid ${COLORS.gray};
  }

  .limit {
    color: ${COLORS.deepGray};
    border: none !important;
    cursor: default;
  }
`;

const PageNumber = styled.div`
  width: 1.8vw;
  height: 70%;
  color: ${COLORS.fontColor};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1vw;
  font-weight: 500;
  border-radius: 5px;
  box-sizing: border-box;
  margin: 0 0.5%;
  border: 0.18vw solid transparent;

  cursor: pointer;
  transition: 0.2s all;

  &:hover {
    border: 0.18vw solid ${CLOUDN_COLORS.skyBlue};
  }
`;
